// React
import Select from 'react-select';
import { Col, Input, Row } from 'reactstrap';
import React, { useState, useEffect } from 'react';

// Helpers
import * as url from '../../helpers/url_helper';
import { APIClient } from '../../helpers/api_helper';

export const SearchGroup = ({ handleSearch }) => {
  const [statusOptions, setStatusOptions] = useState([]);
  const [search, setSearch] = useState({
    cpf: '',
    name: '',
    proposal_id: '',
    status_id: '',
  });

  const api = new APIClient();

  const getProposalStatus = async () => {
    let findStatus = await api.get(url.BASE + '/proposal/get-status');

    if (findStatus) {
      setStatusOptions(
        await findStatus.map((item) => ({
          value: item.id,
          label: item.name,
        }))
      );
    }
  };

  const findSelectOptionByStatusId = (statusId) => {
    let option = statusOptions.find((item) => item.value === statusId);

    return option;
  };

  useEffect(() => {
    let savedSearch = JSON.parse(sessionStorage.getItem('searchGroup'));

    if (savedSearch) {
      setSearch(savedSearch);
    }
  }, []);

  useEffect(() => {
    getProposalStatus();
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch(search);
      }}
    >
      <Row xs={12} md={12} lg={12} className="d-flex align-items-center m-3">
        <Col xs={4} md={4} lg={4}>
          <div className="search-box">
            <input
              id="search"
              type="text"
              name="name"
              className="form-control search"
              value={search?.name}
              placeholder="Pesquisar por nome..."
              onChange={(e) => {
                const { value } = e.target;
                if (value.length === 0) {
                  handleSearch({
                    ...search,
                    name: '',
                  });
                }
                setSearch({
                  ...search,
                  [e.target.name]: value,
                });
              }}
            />
            <i className="ri-search-line search-icon"></i>
          </div>
        </Col>

        <Col xs={2} md={2} lg={2}>
          <Input
            id="search"
            type="text"
            name="cpf"
            className="form-control search"
            value={search?.cpf}
            placeholder="Pesquisar por CPF..."
            onChange={(e) => {
              const { value } = e.target;
              if (value.length === 0) {
                handleSearch({
                  ...search,
                  cpf: '',
                });
              }
              setSearch({
                ...search,
                [e.target.name]: value,
              });
            }}
          />
        </Col>

        <Col xs={2} md={2} lg={2}>
          <Input
            id="search"
            type="text"
            name="proposal_id"
            className="form-control search"
            value={search?.proposal_id}
            placeholder="N° da Proposta..."
            onChange={(e) => {
              const { value } = e.target;
              if (value.length === 0) {
                handleSearch({
                  ...search,
                  proposal_id: '',
                });
              }
              setSearch({
                ...search,
                [e.target.name]: value,
              });
            }}
          />
        </Col>

        <Col xs={3} md={3} lg={3}>
          <Select
            id="search"
            isClearable={true}
            value={findSelectOptionByStatusId(search.status_id)}
            options={statusOptions || []}
            placeholder="Situação da Proposta"
            onChange={(e) => {
              if (e !== null) {
                setSearch({
                  ...search,
                  status_id: e.value,
                });
                handleSearch({
                  ...search,
                  status_id: e.value,
                });
              } else {
                setSearch({
                  ...search,
                  status_id: '',
                });
                handleSearch({
                  ...search,
                  status_id: '',
                });
              }
            }}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </Col>
        <Col xs={1} md={1} lg={1}>
          <button
            type="submit"
            className="btn btn-primary btn-label waves-effect waves-light"
          >
            <i className="ri-search-2-line label-icon align-middle fs-16 me-2"></i>{' '}
            Pesquisar
          </button>
        </Col>
        <Input type="submit" hidden />
      </Row>
    </form>
  );
};
